/**
 * JOZones — Intervention zones
 */
import React from "react";
import { MapPin } from "lucide-react";
import { useSettings } from "@/lib/useSettings";

export default function JOZones() {
  const { settings: s } = useSettings();
  const zones = s?.intervention_zones_list || [];
  if (!zones.length) return null;

  return (
    <section className="jo-section" data-testid="jo-zones">
      <div className="jo-container">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <div className="jo-section-eyebrow">— Là où nous intervenons</div>
            <h2 className="jo-section-title mb-6" style={{ hyphens: "none", WebkitHyphens: "none", overflowWrap: "normal", wordBreak: "normal" }}>
              D'Istres aux <span className="whitespace-nowrap">Alpilles,</span><br />nous cultivons votre extérieur.
            </h2>
            <p className="text-[var(--jdo-muted)] text-base leading-relaxed mb-2 max-w-md">
              Basés à Istres, nous nous déplaçons dans un rayon de {s?.intervention_radius_km || 40} km autour de notre jardinerie.
            </p>
            <p className="text-[var(--jdo-muted)] text-sm">Devis gratuit · Visite sur place · Visuel 3D</p>
          </div>

          <div className="lg:col-span-7">
            <div className="jo-zones-grid">
              {zones.map(z => (
                <span key={z} className="jo-zone-pill" data-testid={`jo-zone-${z}`}>
                  <MapPin className="w-3.5 h-3.5 inline mr-1.5" style={{ verticalAlign: "-2px" }} />
                  {z}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
